import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../assets/css/news-details.css";
import Seo from "../components/Seo";
import {
    SITE,
    absoluteUrl,
    toIstIso,
    toMetaDescription,
    toTagList,
} from "../utils/seo";

const NewsDetails = ({ type }) => {
    const { slug } = useParams();
    const [news, setNews] = useState();
    const [loading, setLoading] = useState(true);
    const API_URL = process.env.REACT_APP_BKND_URL;
    useEffect(() => {
        fetch(
            `${API_URL}/get-blogs.php?type=${type}&slug=${slug}`
        )
            .then((response) => response.json())
            .then((data) => {
                if (data.status && data.data.length > 0) {
                    setNews(data.data[0]);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.log("News API Error:", error);
                setLoading(false);
            });
    }, [slug]);

    if (loading) {
        return (
            <div className="container py-5 text-center">
                <div className="spinner-border text-danger" role="status">
                    <span className="visually-hidden">
                        Loading...
                    </span>
                </div>
            </div>
        );
    }
    if (!news) {
        return <div className="container py-5">News not found</div>;
    }

    /* ===== SEO values for this article ===== */
    const canonicalPath = `/${type === "blog" ? "blogs" : "news"}/${slug}`;
    const canonicalUrl = absoluteUrl(canonicalPath);
    const publishedTime =
        toIstIso(news.published_time) ||
        toIstIso(news.created_at) ||
        toIstIso(news.publish_date);
    const modifiedTime =
        toIstIso(news.modified_time) || toIstIso(news.updated_at) || publishedTime;
    const section = news.section || (type === "blog" ? "Blog" : SITE.defaultSection);
    const tags = toTagList(news.tags);
    const description = toMetaDescription(news.teaser_text || news.content);
    const imageUrl = absoluteUrl(news.image_url || SITE.logo);

    const articleSchema = {
        "@context": "https://schema.org",
        "@type": type === "blog" ? "BlogPosting" : "NewsArticle",
        mainEntityOfPage: { "@type": "WebPage", "@id": canonicalUrl },
        headline: String(news.title).slice(0, 110),
        description,
        image: [imageUrl],
        datePublished: publishedTime,
        dateModified: modifiedTime,
        inLanguage: SITE.language,
        articleSection: section,
        keywords: tags.join(", "),
        isAccessibleForFree: true,
        author: { "@type": "Organization", name: SITE.name, url: SITE.url },
        publisher: {
            "@type": "NewsMediaOrganization",
            name: SITE.name,
            url: SITE.url,
            logo: { "@type": "ImageObject", url: absoluteUrl(SITE.logo) },
        },
    };

    return (
        <div className="news-details-page">
            <Seo
                type="article"
                title={news.title}
                description={description}
                canonical={canonicalPath}
                image={imageUrl}
                publishedTime={publishedTime}
                modifiedTime={modifiedTime}
                section={section}
                tags={tags}
                jsonLd={articleSchema}
            />
            <div className="container">
                <div className="news-details-card">
                    {/* IMAGE */}
                    <div className="news-image-wrapper">
                        <img
                            src={news.image_url}
                            alt={news.title}
                            className="news-main-image"
                        />
                    </div>
                    {/* CONTENT */}
                    <div className="news-content">
                        <h1 className="news-title">
                            {news.title}
                        </h1>
                        <div className="news-meta">
                            <span>
                                {news.publish_date}
                            </span>
                        </div>
                        {/* TEASER */}
                        {news.content && (
                            <div
                                className="news-teaser"
                                dangerouslySetInnerHTML={{
                                    __html: news.content,
                                }}
                            ></div>
                        )}
                        {/* DESCRIPTION */}
                        {/* <div
                            className="news-description"
                            dangerouslySetInnerHTML={{
                                __html: news.description,
                            }}
                        ></div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default NewsDetails;